import { ServiceProvider } from "../../../../domain/service_provider/ServiceProvider";
import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { ServiceProviderName } from "../../../../domain/service_provider/ServiceProviderName";
import { ServiceProviderId } from "../../../../domain/service_provider/ServiceProviderId";
import { ServiceProviderSpId } from "../../../../domain/service_provider/ServiceProviderSpId";
import { ServiceProviderSharedPassword } from "../../../../domain/service_provider/ServiceProviderSharedPassword";

export const useServiceProviderInformation = (): ServiceProvider => {
    const informationJson = useSelector((state: State) => state.adminServiceProvider.serviceProviderInformation);

    return ServiceProvider.from(
        ServiceProviderId.fromString(informationJson.id),
        ServiceProviderName.fromString(informationJson.name),
        ServiceProviderSpId.fromString(informationJson.spId),
        ServiceProviderSharedPassword.fromString(informationJson.sharedPassword)
    );
};
